export default __webpack_public_path__ + "static/ll_banner_newsletter_mobile-f7e8de0eaec780690810e2d32ac45748.jpg";